// Axios:
const axios = require('axios').default;

const stripeHandler = function (next) {

	const donationValue = Number(next.dataset.donationAmount); // get the donation amount from DOM
	const formSubmitBtn = next.querySelector('button#submit');
	const isMembership = (typeof next.dataset.membershipAmount !== "undefined");
	const membershipValue = (isMembership) ? Number(next.dataset.membershipAmount) : 0; // get the membership amount from DOM
	const isFounder = (isMembership && membershipValue == 55) ? true : false; // get the founder status from membership amount
	const totalCheckoutAmount = Number(donationValue + membershipValue); // calculate the total amount as a string
	const paymentType = (isMembership) ? 'membership' : 'donation'; // Donation/Payment 'type'
	const existingPi = false;

	console.log(membershipValue, isMembership)

	const paymentForm = next.querySelector('#donateCheckout, #membershipCheckout')
	if (paymentForm !== null) {
		paymentForm.addEventListener('submit', handleSubmit)
	}

	const stripe = Stripe(process.env.MIX_STRIPE_PUBLISHABLE_KEY);
	let elements;

	// See Stripe Appearance API...
	const customTheme = {
		theme: 'flat',
		variables: {
			colorPrimary: '#6dc82c',
			// colorBackground: '#f9f9f9',
			colorText: '#434343',
			colorDanger: '#df1b41',
			// fontFamily: 'Ideal Sans, system-ui, sans-serif',
			spacingUnit: '0.3rem',
			spacingGridRow: '1rem',
			// borderRadius: '4px',
		}
	};

	const initStripe = function (paymentType, value, membershipValue = 0, isFounder = false) {

		function buildElements(client_secret) {
			// Render the form using the clientSecret
			const options = {
				clientSecret: client_secret,
				appearance: customTheme
			};
			// Set up Stripe.js and Elements to use in checkout form, passing the client secret obtained in step 3
			elements = stripe.elements(options);

			// Create and mount the Payment Element
			const paymentElement = elements.create('payment');
			paymentElement.mount('#payment-element');
			enableSubmit()
		}

		// Check if there is an existing payment intent in the user's session, otherwise generate one ans return it
		axios.get('/!/pi-check/', {
			params: {
				type: paymentType,
			}
		})
			.then(function (response) {
				if (response.data.secret) {
					buildElements(response.data.secret)
				} else {
					return axios.get('/!/payment/' + paymentType, {
							params: {
								value: value,
								isFounder: isFounder,
								membershipValue: membershipValue
							}
						})
						.then(function (response) {
							// handle success
							buildElements(response.data.client_secret)
						})
						.catch(function (error) {
							// handle error
							console.error(error);
						})
				}
			});

	}

	const enableSubmit = function () {
		// set small timeout to allow for Stripe elements animation
		setTimeout(function () {
			formSubmitBtn.removeAttribute('disabled')
			formSubmitBtn.classList.remove('disabled')
		}, 1000)
	}

	async function handleSubmit(e) {
		e.preventDefault();
		setLoading(true);

		const { error } = await stripe.confirmPayment({
			elements,
			confirmParams: {
				// Make sure to change this to your payment completion page
				return_url: "https://" + location.host + "/!/checkoutConfirmation/" + paymentType,
				// redirect: 'if_required'
			},
		});

		// This point will only be reached if there is an immediate error when
		// confirming the payment. Otherwise, your customer will be redirected to
		// your `return_url`. For some payment methods like iDEAL, your customer will
		// be redirected to an intermediate site first to authorize the payment, then
		// redirected to the `return_url`.
		if (error.type === "card_error" || error.type === "validation_error") {
			showMessage(error.message);
		} else {
			showMessage("An unexpected error occurred.");
		}

		setLoading(false);
	}

	// Fetches the payment intent status after payment submission
	async function checkStatus() {
		const clientSecret = new URLSearchParams(window.location.search).get(
			"payment_intent_client_secret"
		);

		if (!clientSecret) {
			return;
		}

		const { paymentIntent } = await stripe.retrievePaymentIntent(clientSecret);

		switch (paymentIntent.status) {
			case "succeeded":
				showMessage("Payment succeeded!");
				break;
			case "processing":
				showMessage("Your payment is processing.");
				break;
			case "requires_payment_method":
				showMessage("Your payment was not successful, please try again.");
				break;
			default:
				showMessage("Something went wrong.");
				break;
		}
	}

	// Form UI loading state during payment
	function setLoading(state) {
		(state) ? paymentForm.classList.add('loading') : paymentForm.classList.remove('loading')
	}

	// Message popup
	function showMessage(messageText) {
		const messageContainer = paymentForm.querySelector("#error-message");

		messageContainer.classList.remove("hidden");
		messageContainer.textContent = messageText;

		setTimeout(function () {
			messageContainer.classList.add("hidden");
			messageContainer.textContent = "";
		}, 4000);
	}

	// Stripe GO:
	initStripe(paymentType, totalCheckoutAmount, membershipValue, isFounder)
	checkStatus()

}

export default stripeHandler
